import {Button, Card, Col, Collapse, Container, Input, Row} from "reactstrap";
import Multiselect from "multiselect-react-dropdown";
import {firebaseConstants, getDb, multiselectDropdownStyle,} from "../../util/Constants";
import DataTable from "react-data-table-component";
import numeral from "numeral";
import {useEffect, useMemo, useRef, useState} from "react";
import {collection, doc, getDoc, getDocs, query, where,} from "firebase/firestore";
import _ from "lodash";
import CsvDownloader from "react-csv-downloader";
import {useParams} from "react-router-dom";
import InputRange from "react-input-range";
import classNames from "classnames";

import "react-input-range/lib/css/index.css";

let timer = null;

export default function StrengthDetails({ signedInUser }) {
  const [showing, setShowing] = useState("all");
  const [leaderboard, setLeaderboard] = useState([]);
  const [showingData, setShowingData] = useState([]);
  const [activeLeaderboard, setActiveLeaderboard] = useState([]);
  const [departmentsData, setDepartmentsData] = useState([]);
  const [regionsData, setRegionsData] = useState([]);
  const [capabilitiesData, setCapabilitiesData] = useState([]);
  const [department, setDepartment] = useState(null);
  const [regions, setRegions] = useState([]);
  const [filters, setFilters] = useState({});
  const [loadingLeaderboard, setLoadingLeaderboard] = useState(true);
  const [nameSearchData, setNameSearchData] = useState([]);
  const [emailSearchData, setEmailSearchData] = useState([]);
  const [loadingSearchData, setLoadingSearchData] = useState(false);
  const [projectType, setProjectType] = useState("");
  const [registrationFeilds, setRegistrationFeilds] = useState([]);
  const [showFilters, setShowFilters] = useState(false);
  const { eventId } = useParams();
  const [rangeValues, setRangeValues] = useState({
    currentScore: {
      min: 0,
      max: 40000,
    },
  });
  const [behaviourValues, setBehaviourValues] = useState({
    behaviourScore: {
      min: 0,
      max: 30000,
    },
  });
  const [aptitudeValues, setAptitudeValues] = useState({
    aptitudeScore: {
      min: 0,
      max: 5000,
    },
  });
  const [cognitiveValues, setCognitiveValues] = useState({
    cognitiveScore: {
      min: 0,
      max: 5000,
    },
  });
  const [csvData, setCsvData] = useState([]);

  const departmentDropdown = useRef();
  const regionDropdown = useRef();
  const searchByNameDropdown = useRef();
  const searchByEmailDropdown = useRef();

  const db = getDb();
  const usersRef = collection(db, firebaseConstants.dbUsers);
  const utilRef = collection(db, firebaseConstants.dbUtil);
  const regionRef = collection(db, firebaseConstants.dbRegions);
  const departmentRef = collection(db, firebaseConstants.dbDepartments);

  useEffect(async () => {
    getEventData().then((data) => {
      console.log(data, "data");
      setCapabilitiesData(data.capabilitiesData);
      setProjectType(data.projectType);
      setRegistrationFeilds(data.registrationFeilds);
      setDepartmentsData(data.departments);
      setRegionsData(data.regions);
    });
    // getMetaData().then(data => {
    //     setCapabilitiesData(data.capabilities);
    // });
    await getLeaderboard();

    // fetchDepartments()
    // fetchRegions()
  }, []);

  useEffect(() => {
    exportToCSV();
  }, [activeLeaderboard]);

  useEffect(() => {
    if (leaderboard.length > 0) {
      if (showing === "completed") {
        const _data = leaderboard.filter((user) => user.completedOnce);
        setShowingData(_data);
      } else {
        setShowingData(leaderboard);
      }
    }
  }, [showing, leaderboard]);

  const getEventData = async () => {
    const docRef = doc(db, "Events", eventId);
    const docSnap = await getDoc(docRef);
    if (docSnap.exists()) {
      const data = docSnap.data().selectedLevels.competencies.map((e) => {
        return e.name;
      });
      return {
        capabilitiesData: data,
        projectType: docSnap.data().projectType,
        registrationFeilds: docSnap.data().registrationFields,
        regions: docSnap.data().region,
        departments: docSnap.data().departments,
      };
    }
  };
  const filteredData = useMemo(() => {
    console.log("111");
    let _data = showingData;
    console.log(_data);
    let filtersRecord = {};

    if (department || regions.length > 0) {
      _data = _data.filter((_user) => {
        let isInDept = true,
          isInRegion = true;

        if (regions.length > 0) {
          console.log(regions);
          filtersRecord = { ...filtersRecord, regions: regions };
          isInRegion = regions
            .map((e) => e.toLowerCase())
            .includes(_user.region.toLowerCase());
        }
        if (department) {
          console.log(department);
          filtersRecord = { ...filtersRecord, department: department };
          isInDept = _user.department === department;
        }

        return isInDept && isInRegion;
      });
    }
    // if (!_.isEmpty(filters)) {

    _data = _data.filter((_user) => {
      let shouldReturn = true;
      for (const _capability of Object.keys(filters)) {
        const averagePercentage = _user?.capabilities[_capability]?.averagePercentage ?? 0;
        if (averagePercentage < Number(filters[_capability])) {
          shouldReturn = false;
          break;
        }
      }

      return shouldReturn;
    });

    if (rangeValues) {
      _data = _data.filter((item) => {
        for (var key in rangeValues) {
          if (
            item[key] < rangeValues[key].min ||
            item[key] > rangeValues[key].max
          ) {
            return false;
          }
        }
        return true;
      });
    }
    if (behaviourValues) {
      _data = _data.filter((item) => {
        for (var key in behaviourValues) {
          if (
            item[key] < behaviourValues[key].min ||
            item[key] > behaviourValues[key].max
          ) {
            return false;
          }
        }
        return true;
      });
    }
    if (aptitudeValues) {
      _data = _data.filter((item) => {
        for (var key in aptitudeValues) {
          if (
            item[key] < aptitudeValues[key].min ||
            item[key] > aptitudeValues[key].max
          ) {
            return false;
          }
        }
        return true;
      });
    }
    if (cognitiveValues) {
      console.log("Communication", cognitiveValues);
      _data = _data.filter((item) => {
        for (var key in cognitiveValues) {
          if (
            item[key] < cognitiveValues[key].min ||
            item[key] > cognitiveValues[key].max
          ) {
            return false;
          }
        }
        return true;
      });
    }

    setActiveLeaderboard(_data);
    // return _data;
  }, [
    filters,
    showingData,
    rangeValues,
    behaviourValues,
    cognitiveValues,
    aptitudeValues,
    department,
    regions,
  ]);
  // const filterMethods = (item, filterKey, value) => {
  //     let itemKey = filterKey;
  //     console.log(itemKey);
  //     console.log(item)
  //     console.log(value, "data");

  //     return (
  //         (item[itemKey] === undefined || Array.isArray(item[itemKey]))
  //             ? !item[itemKey].includes(value)
  //             : (typeof value === "object")
  //                 ? (item[itemKey] < value.min || item[itemKey] > value.max)
  //                 : (item[itemKey] !== value)
  //     );

  // };

  const getMetaData = async () => {
    let _dept = [],
      _regions = [],
      _capabilities = [];
    const docRef = doc(utilRef, "meta");
    const docSnap = await getDoc(docRef);
    if (docSnap.exists()) {
      const data = docSnap.data();
      _dept = data.departments ? data.departments : [];
      _regions = data.regions ? data.regions : [];
      _capabilities = data.capabilities ? data.capabilities : [];
    }

    return {
      departments: _dept,
      regions: _regions,
      capabilities: _capabilities,
    };
  };
  //changes by me
  // const fetchDepartments = async () => {
  //     const querySnapshot = await getDocs(departmentRef);
  //     let dataArr = []
  //     querySnapshot.forEach((doc) => {
  //         dataArr.push(
  //             {
  //                 department: doc.data().department,
  //             }
  //         )
  //     });
  //     setDepartmentsData(dataArr.map((e) => e.department));
  // }

  // const fetchRegions = async () => {
  //     const querySnapshot = await getDocs(regionRef);
  //     let dataArr = []
  //     querySnapshot.forEach((doc) => {
  //         dataArr.push(
  //             {
  //                 region: doc.data().region,
  //             }
  //         )
  //     })
  //     setRegionsData(dataArr.map((e) => e.region));
  // }

  const getLeaderboard = async () => {
    let data = [],
      q = null;

    q = query(usersRef, where("eventId", "==", eventId));
    const querySnapshot = await getDocs(q);

    querySnapshot.docs.forEach((doc, index) => {
      const _user = parseUser({ rank: index + 1, id: doc.id, ...doc.data() });
      if (!_.isEmpty(_user?.capabilities)) {
        console.log(_user);
        data.push(_user);
      }

      // startRank++;
    });
    console.log(data);
    setLeaderboard(data);
    setActiveLeaderboard(data);

    const _searchData = data.slice(0, data.length % 5).map((user) => ({
      ...user,
      value: (
        <span>
          {user.name} - <span className="">{user.email}</span>
        </span>
      ),
    }));
    setNameSearchData(_searchData);
    setEmailSearchData(_searchData);

    setLoadingLeaderboard(false);
  };

  const getConstraints = () => {
    const constraints = [];

    if (department) {
      constraints.push(where("department", "==", department));
    }
    if (regions.length > 0) {
      constraints.push(where("region", "in", regions));
    }
    return constraints;
  };

  const handleSearch = async (searchText, searchBy) => {
    let userData = [];

    if (searchText) {
      const unsortedData = activeLeaderboard
        .filter(
          (user) =>
            user[searchBy].toLowerCase().startsWith(searchText.toLowerCase()) ||
            user[searchBy].toLowerCase().includes(searchText.toLowerCase())
        )
        .slice(0, 10)
        .map((user) => ({
          ...user,
          value: (
            <span>
              {user.name} - <span className="">{user.email}</span>
            </span>
          ),
        }));
      userData = _.orderBy(unsortedData, [searchBy], ["desc"]);
    } else {
      userData = activeLeaderboard.slice(0, 10).map((user) => ({
        ...user,
        value: (
          <span>
            {user.name} - <span className="">{user.email}</span>
          </span>
        ),
      }));
    }

    searchBy === "name"
      ? setNameSearchData(userData)
      : setEmailSearchData(userData);
    setLoadingSearchData(false);
  };

  const removeSearch = () => {
    if (showing === "completed") {
      const _data = leaderboard.filter((user) => user.completedOnce);
      setActiveLeaderboard(_data);
    } else {
      setActiveLeaderboard(leaderboard);
    }
  };

  const clearFilters = () => {
    // departmentDropdown.current.resetSelectedValues();
    // regionDropdown.current.resetSelectedValues();
    // searchByNameDropdown.current.resetSelectedValues();
    // searchByEmailDropdown.current.resetSelectedValues();
    // setDepartment(null);
    // setRegions([]);
    removeSearch();
    setFilters({});
    setBehaviourValues({
      behaviourScore: {
        min: 0,
        max: 30000,
      },
    });
    setRangeValues({
      currentScore: {
        min: 0,
        max: 40000,
      },
    });
    setAptitudeValues({
      aptitudeScore: {
        min: 0,
        max: 5000,
      },
    });
    setCognitiveValues({
      cognitiveScore: {
        min: 0,
        max: 5000,
      },
    });
  };

  const parseUser = (_user) => {
    let total = {};

    if (_user.capabilities) {
    } else {
    }

    Object.keys(_user.capabilities).map((capabilityName) => {
      const capability = _user.capabilities[capabilityName];
      if (!total[capabilityName]) {
        total[capabilityName] = {
          levels: 0,
          achievedScore: 0,
          percentage: 0,
          totalQuestions: 0,
          totalScore: 0,
        };
      }

      if (capability.scores) {
        const percentages = [];
        
        Object.keys(capability.scores).map((levelName) => {
          const scores = capability.scores[levelName];

          // Prevent to show mini-games data in levels (same as UserStrengths.jsx)
          const fieldNames = ['level2', 'level4', 'level6', 'level8', 'level10'];
          if (!fieldNames.includes(levelName)) {
            if (scores.totalQuestions > 0) {
              total[capabilityName].levels += 1;
              total[capabilityName].achievedScore += scores.achievedScore ?? 0;
              total[capabilityName].percentage += scores.percentage ?? 0;
              total[capabilityName].totalQuestions += scores.totalQuestions ?? 0;
              total[capabilityName].totalScore += scores.totalScore ?? 0;
            }

            // Calculate percentage for each level (only include levels where totalScore > 0)
            if (scores.totalScore > 0) {
              const percentage = Math.round((scores.achievedScore / scores.totalScore) * 100);
              percentages.push(percentage);
            }
          }
        });

        // Calculate average of all collected percentages and round the result
        if (percentages.length > 0) {
          const sum = percentages.reduce((acc, val) => acc + val, 0);
          total[capabilityName].averagePercentage = Math.round(sum / percentages.length);
        } else {
          total[capabilityName].averagePercentage = 0;
        }
      } else {
        total[capabilityName].averagePercentage = 0;
      }
      console.log(capabilityName,total[capabilityName].achievedScore);
      console.log(capabilityName,total[capabilityName].totalScore);
    });

    return { ..._user, capabilities: total };
  };

  const getColumns = () => {
    const _columns = [
      { name: "#", center: true, width: "50px", selector: (row) => row.rank },
      { name: "Name", wrap: true, selector: (row) => row.name },
      { name: "Email", wrap: true, selector: (row) => row.email },
      // { name: 'Region', center: true, minWidth: '5%', selector: row => row.region },
      // { name: 'Dept.', center: true, minWidth: '5%', selector: row => row.department },
    ];
    if (!checkProjectType()) {
      _columns.push(
        {
          name: "Behaviour",
          center: true,
          minWidth: "8%",
          selector: (row) => row.completedOnce,
          cell: (row) => {
            return (
              <div className="text-center">
                <div>
                  {/*<i className="fas fa-check text-success"/>*/}
                  {/*<span className="mx-1">&#9679;</span>*/}
                  {numeral(row.behaviourScore).format("0,0")}
                </div>
              </div>
            );
          },
        },

        {
          name: "Aptitude",
          center: true,
          minWidth: "8%",
          selector: (row) => row.completedOnce,
          cell: (row) => {
            return (
              <div className="text-center">
                <div>
                  {/*<i className="fas fa-check text-success"/>*/}
                  {/*<span className="mx-1">&#9679;</span>*/}
                  {numeral(row.aptitudeScore).format("0,0")}
                </div>
              </div>
            );
          },
        },

        {
          name: "Cognitive",
          center: true,
          minWidth: "8%",
          selector: (row) => row.completedOnce,
          cell: (row) => {
            return (
              <div className="text-center">
                <div>
                  {/*<i className="fas fa-check text-success"/>*/}
                  {/*<span className="mx-1">&#9679;</span>*/}
                  {numeral(row.cognitiveScore).format("0,0")}
                  {/* cognitiveScore */}
                </div>
              </div>
            );
          },
        }
      );
    }

    _columns.push({
      name: checkProjectType() ? "Score" : "Total Score",
      center: true,
      minWidth: "10%",
      selector: (row) => row.completedOnce,
      cell: (row) => {
        return (
          <div className="text-center">
            <div>
              {/*<i className="fas fa-check text-success"/>*/}
              {/*<span className="mx-1">&#9679;</span>*/}
              {numeral(row.currentScore).format("0,0")}
            </div>
          </div>
        );
      },
    });
    console.log([
      ..._columns,
      ...capabilitiesData?.map((_capability) => {
        return {
          name: _.startCase(_capability),
          center: true,
          minWidth: "10%",
          selector: (row) => row.capabilities,
          cell: (row) => {
            return row.capabilities && row.capabilities[_capability]?.levels ? (
                <span>
                {/* progress old formula */}
                  {/* {numeral(
                  row?.capabilities[_capability]?.percentage /
                    row.capabilities[_capability].levels
                ).format("0,0.[0]")}
                % */}
                  {row.capabilities[_capability]?.averagePercentage ?? 0}%
              </span>
            ) : (
                <span>0% </span>
            );
          },
        };
      }),
    ])
    return [
      ..._columns,
      ...capabilitiesData?.map((_capability) => {
        return {
          name: _.startCase(_capability),
          center: true,
          minWidth: "10%",
          selector: (row) => row.capabilities,
          cell: (row) => {
            return row.capabilities && row.capabilities[_capability]?.levels ? (
              <span>
                {/* progress old formula */}
                {/* {numeral(
                  row?.capabilities[_capability]?.percentage /
                    row.capabilities[_capability].levels
                ).format("0,0.[0]")}
                % */}
                {row.capabilities[_capability]?.averagePercentage ?? 0}%
              </span>
            ) : (
              <span>0% </span>
            );
          },
        };
      }),
    ];
  };

  const exportToCSV = async () => {
    const data = activeLeaderboard.map((_user) => ({
      Rank: _user.rank,
      Name: _user.name,
      Email: _user.id,
      // Region: _user.region,
      // Department: _user.department,
      ["Behaviour Score"]: _user.behaviourScore,
      ["Aptitude Score"]: _user.aptitudeScore,
      ["Cognitive Score"]: _user.cognitiveScore,
      ["Total Score"]: _user.currentScore,
      [capabilitiesData.map((e) => e)]: capabilitiesData.map((e, i) => {
        return _user?.capabilities[e]?.averagePercentage ?? 0;
      }),
    }));

    setCsvData(data);
  };

  // changes by me

  const checkProjectType = () => {
    return projectType === "progress";
  };

  return (
    <>
      <Container fluid>
        {/*<Row className="">*/}
        <div>
          <div className="border-0 d-flex justify-content-between align-items-center">
            <div className="d-flex align-items-center">
              <h1 className="mb-0 custom-font letterSpacing d-flex align-items-center">
                <input
                  type="checkbox"
                  id="filters-checkbox"
                  checked={showFilters}
                  onChange={(e) => {
                    console.log(e.target.checked);
                    setShowFilters(e.target.checked);
                  }}
                />
                <label htmlFor="filters-checkbox" className="toggle-filters">
                  <div className="bars" id="bar1"></div>
                  <div className="bars" id="bar2"></div>
                  <div className="bars" id="bar3"></div>
                </label>
                <span className="ml-2 mb-1">Filters</span>
              </h1>
              {/*<span className="ml-3">Filters items</span>*/}
            </div>
            <div className="d-flex justify-content-start">
              <label
                htmlFor="site_state"
                className={classNames("fw-bold", {
                  "text-muted": showing !== "all",
                })}
              >
                All Users
                {/*<span className="badge bg-primary small ms-2">discounted</span>*/}
              </label>
              <label className="switch mx-2">
                <input
                  id="site_state"
                  type="checkbox"
                  onChange={({ target }) => {
                    target.checked
                      ? setShowing("completed")
                      : setShowing("all");
                  }}
                />
                <span className="switch-slider always-on round" />
              </label>
              {/*<div className="form-check form-switch" style={{paddingLeft: 0}}>*/}
              {/*    <input type="checkbox" className="form-check-input always-on-switch" id="site_state"*/}
              {/*           onChange={({target}) => {*/}
              {/*               target.checked ? setShowing('all') : setShowing('completed')*/}
              {/*           }}*/}
              {/*    />*/}
              {/*</div>*/}
              <label
                htmlFor="site_state"
                className={classNames("fw-bold", {
                  "text-muted": showing !== "completed",
                })}
              >
                Only Completed
              </label>
            </div>
          </div>

          <Collapse isOpen={showFilters}>
            <Row>
              {checkProjectType() && (
                <>
                  {registrationFeilds.includes("department") && (
                    <Col md={2}>
                      <Multiselect
                        ref={departmentDropdown}
                        className="form-control-alternative mb-1  bg-white"
                        isObject={false}
                        showArrow={true}
                        selectionLimit={1}
                        placeholder="Department"
                        options={departmentsData}
                        closeIcon="cancel"
                        onSelect={(list, item) => setDepartment(item)}
                        onRemove={(list, item) => setDepartment(null)}
                        style={multiselectDropdownStyle}
                      />
                      <p className="mb-0 small text-muted float-right">
                        Single Select
                      </p>
                    </Col>
                  )}
                  {registrationFeilds.includes("region") && (
                    <Col md={2}>
                      <Multiselect
                        ref={regionDropdown}
                        className="form-control-alternative mb-1 bg-white"
                        isObject={false}
                        showArrow={true}
                        placeholder="Region"
                        options={regionsData}
                        closeIcon="cancel"
                        onSelect={(list, item) =>
                          setRegions([...regions, item])
                        }
                        onRemove={(list, item) =>
                          setRegions(regions.filter((i) => i !== item))
                        }
                        style={multiselectDropdownStyle}
                      />
                      <p className="mb-0 small text-muted float-right">
                        Multi Select
                      </p>
                    </Col>
                  )}
                </>
              )}
            </Row>
            <Row className="mb-3">
              {capabilitiesData.length > 0 &&
                capabilitiesData.map((_capability) => (
                  <Col md={2}>
                    <Input
                      type="number"
                      min="0"
                      max="100"
                      placeholder={_.startCase(_capability)}
                      className="form-control-alternative"
                      name={_capability}
                      value={filters[_capability] || ""}
                      onChange={(e) => {
                        setFilters({
                          ...filters,
                          [e.target.name]: e.target.value,
                        });
                      }}
                      maxLength={3}
                      onInput={(object) => {
                        if (
                          object.target.value.length > object.target.maxLength
                        )
                          object.target.value = object.target.value.slice(
                            0,
                            object.target.maxLength
                          );
                      }}
                    />
                  </Col>
                ))}
            </Row>
            <h4>Scoring</h4>
            <Row className=" mb-5 d-flex justify-content-between px-2">
              {!checkProjectType() && (
                <>
                  {" "}
                  <Col md={3}>
                    <h5 className="text-muted">Behaviour Score</h5>
                    <Row className="mb-3">
                      <Col>
                        <Input
                          min={"0"}
                          max={"30000"}
                          maxLength={5}
                          onInput={(object) => {
                            if (
                              object.target.value.length >
                              object.target.maxLength
                            )
                              object.target.value = object.target.value.slice(
                                0,
                                object.target.maxLength
                              );
                          }}
                          value={behaviourValues?.behaviourScore.min}
                          onChange={(e) => {
                            setBehaviourValues((prevState) => ({
                              ...prevState,
                              behaviourScore: {
                                ...prevState.behaviourScore,
                                min: parseInt(e.target.value),
                              },
                            }));
                          }}
                          type="number"
                          className="form-control-alternative"
                        />
                      </Col>
                      <Col>
                        <Input
                          value={behaviourValues?.behaviourScore.max}
                          min={"0"}
                          max={"30000"}
                          maxLength={5}
                          onInput={(object) => {
                            if (
                              object.target.value.length >
                              object.target.maxLength
                            )
                              object.target.value = object.target.value.slice(
                                0,
                                object.target.maxLength
                              );
                          }}
                          onChange={(e) => {
                            setBehaviourValues((prevState) => ({
                              ...prevState,
                              behaviourScore: {
                                ...prevState.behaviourScore,
                                max: parseInt(e.target.value),
                              },
                            }));
                          }}
                          type="number"
                          className="form-control-alternative"
                        />
                      </Col>
                    </Row>
                    <InputRange
                      minValue={0}
                      maxValue={30000}
                      value={behaviourValues?.behaviourScore}
                      onChange={(value) =>
                        setBehaviourValues((prev) => ({
                          ...prev,
                          behaviourScore: value,
                        }))
                      }
                    />
                  </Col>
                  <Col md={3}>
                    <h5 className="text-muted">Aptitude Score</h5>

                    <Row className="mb-3">
                      <Col>
                        <Input
                          value={aptitudeValues?.aptitudeScore.min}
                          min={"0"}
                          max={"5000"}
                          maxLength={4}
                          onInput={(object) => {
                            if (
                              object.target.value.length >
                              object.target.maxLength
                            )
                              object.target.value = object.target.value.slice(
                                0,
                                object.target.maxLength
                              );
                          }}
                          onChange={(e) => {
                            setAptitudeValues((prevState) => ({
                              ...prevState,
                              aptitudeScore: {
                                ...prevState.aptitudeScore,
                                min: parseInt(e.target.value),
                              },
                            }));
                          }}
                          type="number"
                          className="form-control-alternative"
                        />
                      </Col>
                      <Col>
                        <Input
                          min={"0"}
                          max={"5000"}
                          maxLength={4}
                          onInput={(object) => {
                            if (
                              object.target.value.length >
                              object.target.maxLength
                            )
                              object.target.value = object.target.value.slice(
                                0,
                                object.target.maxLength
                              );
                          }}
                          onChange={(e) => {
                            setAptitudeValues((prevState) => ({
                              ...prevState,
                              aptitudeScore: {
                                ...prevState.aptitudeScore,
                                max: parseInt(e.target.value),
                              },
                            }));
                          }}
                          value={aptitudeValues?.aptitudeScore.max}
                          type="number"
                          className="form-control-alternative"
                        />
                      </Col>
                    </Row>
                    <InputRange
                      minValue={0}
                      maxValue={5000}
                      value={aptitudeValues?.aptitudeScore}
                      onChange={(value) =>
                        setAptitudeValues((prev) => ({
                          ...prev,
                          aptitudeScore: value,
                        }))
                      }
                    />
                  </Col>
                  <Col md={3}>
                    <h5 className="text-muted">Cognitive Score</h5>

                    <Row className="mb-3">
                      <Col>
                        <Input
                          min={"0"}
                          max={"5000"}
                          maxLength={4}
                          onInput={(object) => {
                            if (
                              object.target.value.length >
                              object.target.maxLength
                            )
                              object.target.value = object.target.value.slice(
                                0,
                                object.target.maxLength
                              );
                          }}
                          onChange={(e) => {
                            setCognitiveValues((prevState) => ({
                              ...prevState,
                              cognitiveScore: {
                                ...prevState.cognitiveScore,
                                min: parseInt(e.target.value),
                              },
                            }));
                          }}
                          value={cognitiveValues?.cognitiveScore.min}
                          type="number"
                          className="form-control-alternative"
                        />
                      </Col>

                      <Col>
                        <Input
                          min={"0"}
                          max={"5000"}
                          maxLength={4}
                          onInput={(object) => {
                            if (
                              object.target.value.length >
                              object.target.maxLength
                            )
                              object.target.value = object.target.value.slice(
                                0,
                                object.target.maxLength
                              );
                          }}
                          onChange={(e) => {
                            setCognitiveValues((prevState) => ({
                              ...prevState,
                              cognitiveScore: {
                                ...prevState.cognitiveScore,
                                max: parseInt(e.target.value),
                              },
                            }));
                          }}
                          value={cognitiveValues?.cognitiveScore.max}
                          type="number"
                          className="form-control-alternative"
                        />
                      </Col>
                    </Row>
                    <InputRange
                      minValue={0}
                      maxValue={5000}
                      value={cognitiveValues?.cognitiveScore}
                      onChange={(value) =>
                        setCognitiveValues((prev) => ({
                          ...prev,
                          cognitiveScore: value,
                        }))
                      }
                    />
                  </Col>
                </>
              )}
              <Col md={3}>
                <h5 className="text-muted">
                  {checkProjectType() ? `Score` : `Total Score`}
                </h5>

                <Row className="mb-3">
                  <Col>
                    <Input
                      value={rangeValues?.currentScore.min}
                      min={"0"}
                      max={"40000"}
                      maxLength={5}
                      onChange={(e) => {
                        setRangeValues((prevState) => ({
                          ...prevState,
                          currentScore: {
                            ...prevState.currentScore,
                            min: parseInt(e.target.value),
                          },
                        }));
                      }}
                      onInput={(object) => {
                        if (
                          object.target.value.length > object.target.maxLength
                        )
                          object.target.value = object.target.value.slice(
                            0,
                            object.target.maxLength
                          );
                      }}
                      type="number"
                      className="form-control-alternative"
                    />
                  </Col>
                  <Col>
                    <Input
                      value={rangeValues?.currentScore.max}
                      min={"0"}
                      max={"40000"}
                      maxLength={5}
                      onInput={(object) => {
                        if (
                          object.target.value.length > object.target.maxLength
                        )
                          object.target.value = object.target.value.slice(
                            0,
                            object.target.maxLength
                          );
                      }}
                      onChange={(e) => {
                        setRangeValues((prevState) => ({
                          ...prevState,
                          currentScore: {
                            ...prevState.currentScore,
                            max: parseInt(e.target.value),
                          },
                        }));
                      }}
                      type="number"
                      className="form-control-alternative"
                    />
                  </Col>
                </Row>
                <InputRange
                  minValue={0}
                  maxValue={40000}
                  value={rangeValues?.currentScore}
                  onChange={(value) =>
                    setRangeValues((prev) => ({ ...prev, currentScore: value }))
                  }
                />
              </Col>
            </Row>
            <Row>
              <Col className="text-right">
                <Button color="danger" onClick={clearFilters}>
                  Clear
                </Button>
              </Col>
            </Row>
          </Collapse>
        </div>
        {/*</Row>*/}

        <Row className="mt-3 mb-3">
          <Col>
            <Multiselect
              className="form-control-alternative filters-sub"
              ref={searchByNameDropdown}
              // showArrow={true}
              hidePlaceholder={true}
              displayValue="value"
              selectionLimit={1}
              placeholder="Search by Name"
              options={nameSearchData}
              closeIcon="cancel"
              loading={loadingSearchData}
              onSelect={(list, item) => {
                searchByEmailDropdown.current.resetSelectedValues();
                setActiveLeaderboard([item]);
              }}
              onRemove={removeSearch}
              onSearch={(text) => {
                // setNameSearchData([]);
                clearTimeout(timer);
                // if (text.length >= 1) {
                setLoadingSearchData(true);
                timer = setTimeout(() => {
                  handleSearch(text, "name").then((r) => {});
                }, 500);
                // } else {
                //     setLoadingSearchData(false);
                // }
              }}
              style={multiselectDropdownStyle}
            />
          </Col>
          <Col>
            <Multiselect
              className="form-control-alternative filters-sub"
              ref={searchByEmailDropdown}
              // showArrow={true}
              hidePlaceholder={true}
              displayValue="value"
              selectionLimit={1}
              placeholder="Search by Email"
              options={emailSearchData}
              closeIcon="cancel"
              loading={loadingSearchData}
              onSelect={(list, item) => {
                searchByNameDropdown.current.resetSelectedValues();
                setActiveLeaderboard([item]);
              }}
              onRemove={removeSearch}
              onSearch={(text) => {
                // setEmailSearchData([]);
                clearTimeout(timer);
                // if (text.length >= 1) {
                setLoadingSearchData(true);
                timer = setTimeout(() => {
                  handleSearch(text, "email").then((r) => {});
                }, 500);
                // } else {
                //     setLoadingSearchData(false);
                // }
              }}
              style={multiselectDropdownStyle}
            />
          </Col>
          <Col className="d-flex justify-content-end">
            <CsvDownloader
              className="btn btnColor custom-font"
              filename="Progress-strengthDetail"
              columns={""}
              datas={csvData}
              disabled={csvData.length <= 0}
              text="Download CSV"
            />
          </Col>
        </Row>

        <Row className="mb-4">
          <Col>
            <Card className="shadow">
              <DataTable
                columns={getColumns()}
                data={activeLeaderboard}
                progressPending={loadingLeaderboard}
                pagination
                responsive
                persistTableHead
                highlightOnHover
              />
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
}
